import { render, staticRenderFns } from "./SubjectListSkeleton.vue?vue&type=template&id=551212b2&scoped=true&"
import script from "./SubjectListSkeleton.vue?vue&type=script&lang=js&"
export * from "./SubjectListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./SubjectListSkeleton.vue?vue&type=style&index=0&id=551212b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551212b2",
  null
  
)

export default component.exports